import { createGlobalStyle } from "styled-components";

export const Global = createGlobalStyle`
    :root{

        /* Color */
        --color-white-fixed: #FFFFFF;

        --color-brand-0: #F2581B;
        --color-brand-1: #735346;
        --color-brand-2: #332E2C;
        --color-brand-3: #C76038;
        --color-brand-4: #9E5F46;
        --color-brand-5: #473C38;
        --color-brand-5-transparent: #332E2C93;
        
        --color-gray-0: #0B0D0D;
        --color-gray-1: #212529;
        --color-gray-2: #495057;
        --color-gray-3: #868E96;
        --color-gray-4: #ADB5BD;
        --color-gray-5: #CED4DA;
        --color-gray-6: #DEE2E6;
        --color-gray-7: #E9ECEF;
        --color-gray-8: #F1F3F5;
        --color-gray-9: #F8F9FA;
        --color-gray-10: #FDFDFD;

        --color-alert-1: #CD2B31;
        --color-alert-2: #FDD8D8;
        --color-alert-3: #FFE5E5;
        --color-warning: #ffcd07;
        --color-success-1: #18794E;
        --color-success-2: #CCEBD7;
        --color-success-3: #DDF3E4;
        --color-information: #155bcb;

        /* Font */
        --font-family: "Inter", sans-serif;

        --fz-heading-1: 2.6rem;
        --fz-heading-2: 2.2rem;
        --fz-heading-3: 1.8rem;

        --fz-headline: 1.6rem;

        --fz-body: 1.4rem;
        --fz-caption: 1.2rem;

        --fw-bold: 800;
        --fw-semibold: 600;
        --fw-regular: 400;
        
        font-size: 62.5%;

        /* Round */
        --radius: .5rem;
    }

    /* #root{
        height: 100%;
    } */

    /* ScrollBar */
    /* width */
    ::-webkit-scrollbar {
        width: 10px;
    }
    /* Track */
    ::-webkit-scrollbar-track {
        background: var(--color-gray-0);
    }
    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: var(--color-primary);
    }
    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: var(--color-primary);
    }
`;
